import { Container, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import BlogCategories from "../components/BlogCategories";
import BlogList from "../components/BlogList";
import { fetchAllBlogs } from "../firebase/fireStoreServices";

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [blogs, setBlogs] = useState([]);

  // Fetching Blog data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadBlogs = async () => {
      const blogsData = await fetchAllBlogs();
      setBlogs(blogsData);
    };
    loadBlogs();
  }, []);

  const filteredBlogs =
    selectedCategory === "All"
      ? blogs
      : blogs.filter((blog) => blog.category === selectedCategory);

  return (
    <Container maxWidth="lg">
      <Typography
        variant="h4"
        fontWeight="bold"
        color="primary"
        sx={{ my: 4, textAlign: "center" }}
      >
        Latest Blog Posts 📝
      </Typography>

      <Grid container spacing={3}>
        {/* Sidebar for Categories */}
        <Grid item xs={12} md={3}>
          <BlogCategories onCategorySelect={setSelectedCategory} />
        </Grid>
        {/* Blog List */}
        <Grid item xs={12} md={9}>
          <BlogList blogs={filteredBlogs} />
        </Grid>
      </Grid>
    </Container>
  );
}
